(function () {
  function initGaCartSyncSentryFallback() {
    if (!window.dataLayer) {
      console.warn("[Sentry fallback] dataLayer unavailable");
      return;
    }
    
    const reportedCache = new Set();

    // 处理 Sentry 初始化前已经产生的 GTM 事件
    window.dataLayer.forEach(function (item) {
      handleGaCartSyncError(item);
    });

    // 监听后续 dataLayer push
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      const args = Array.from(arguments);
      args.forEach(function (item) {
        handleGaCartSyncError(item);
      });
      return originalPush.apply(window.dataLayer, args);
    };

    function handleGaCartSyncError(data) {
      if (!data || data.event !== "ga_cart_sync_error") {
        return;
      }

      // GTM 已完成 Sentry 上报
      if (data.ga_cart_sync_needs_sentry_fallback !== true) {
        return;
      }

      const diagnosticId = data.ga_cart_sync_diagnostic_id;
      if (!diagnosticId) {
        return;
      }

      // 页面生命周期内去重
      if (reportedCache.has(diagnosticId)) {
        return;
      }

      reportedCache.add(diagnosticId);
      reportToSentry(data);
    }

    function reportToSentry(data) {
      if (!window.Sentry) {
        console.warn("[Sentry fallback] SDK unavailable");
        return;
      }

      const message = `GA Cart Sync Error (${data.ga_cart_sync_diagnostic_id})`;
      const extra = {
        diagnostic_id:
          data.ga_cart_sync_diagnostic_id,

        original_status:
          data.ga_cart_sync_sentry_status,

        original_event_id:
          data.ga_cart_sync_sentry_event_id,

        source:
          "gtm_dataLayer_fallback",

        page_url:
          window.location.href,

        user_agent:
          navigator.userAgent,
      };

      try {
        if (data.ga_cart_sync_error_type === "exception") {
          const error = new Error(message);
          error.name = "GaCartSyncError";
          Sentry.captureException(error, {
            extra,
          });
        } else {
          Sentry.captureMessage(message, {
            level: "error",
            extra,
          });
        }
      } catch (error) {
        console.error("[Sentry fallback] capture failed", error);
      }
    }
  }

  /**
   * 等待 Sentry 初始化完成
   */
  window.addEventListener(
    "sentry-ready",
    function () {
      initGaCartSyncSentryFallback();
    }
  );

})();